import React, { useContext } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext";
import { useLocation } from "react-router-dom";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";

const IdentityUpdateSubmit = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, setAppState, userFlows } = useContext(AppContext);
  const location = useLocation();

  console.log("Current path:", location.pathname);

  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Ngā mihi, kua tae mai tō tono
        </h1>
        <hr />

        <h1 className="intro-title">Thanks, we've got your request</h1>

        <div className="step-container">
          <p className="mb-4">
            We'll contact you once your details have been updated, or if we need
            any more information.{" "}
          </p>
          <p className="mb-4">
            If the document showing your update is from overseas, we'll need to
            see it. We'll let you know how to send the document to us.{" "}
          </p>
          {
            /* Don't display 'email sent' for a name/gender change */
            !userFlows?.isChangeRequested && (
              <p className="mb-4">
                We've sent you an email confirming this request.
              </p>
            )
          }
        </div>

        <div className="step-button-container">
          <SubmitButton
            text={"Return to manage details"}
            onClick={handleNext}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default IdentityUpdateSubmit;
